export const VARIABLE_ITEMS_EXPORT_DEFAULT_MAX_ITEMS = 150_000
export const VARIABLE_ITEMS_EXPORT_CHUNK_SIZE = 5_000

